import React, { PureComponent, Fragment } from 'react';
import { Table } from 'react-bootstrap';
import { Field } from 'redux-form';
import PropTypes from 'prop-types';
import moment from 'moment';

import VerbButton, { VERB_BUTTON_TYPE } from '../../../../../shared/components/VerbButton';
import DisplayOnlyInput from '../../../../../shared/components/formComponents/inputs/DisplayOnlyInput';
import VerbSelect from '../../../../../shared/components/formComponents/inputs/VerbSelect';

export default class RecommendedCollectionsTable extends PureComponent {
    static propTypes = {
        fields: PropTypes.object,
        recommendedCollectionOptions: PropTypes.array,
        handleRecommendedCollectionChange: PropTypes.func,
        selectedRecommendedCollection: PropTypes.object,
        selectedAssignedCollection: PropTypes.object,
        handleAddRecommendedCollection: PropTypes.func,
        currentValues: PropTypes.shape({
            recommendedCollections: PropTypes.array
        })
    };

    _renderTable = (rows) => {
        if (rows && rows.length) {
            return (
                <Table striped={false} bordered={false}>
                    <thead>
                        <tr>
                            <th className={'buttonCell'}>Actions</th>
                            <th>Path Name</th>
                            <th>Date Recommended</th>
                        </tr>
                    </thead>
                    <tbody>{rows}</tbody>
                </Table>
            );
        }
        return null;
    };

    _renderTableRows = (fields) => {
        const {
            currentValues: { recommendedCollections = [] }
        } = this.props;
        const rows = {
            assigned: [],
            recommended: []
        };

        let collectionCode;
        let recommendedDate;
        if (fields && fields.length) {
            fields.forEach((collection, index) => {
                collectionCode = (
                    (recommendedCollections[index] && recommendedCollections[index].code) ||
                    ''
                ).toLocaleLowerCase();
                recommendedDate = recommendedCollections[index] && recommendedCollections[index].recommendedDateTime;

                if (collectionCode) {
                    rows[collectionCode].push(
                        <tr key={index}>
                            <td className={'buttonCell'}>
                                <VerbButton
                                    buttonType={VERB_BUTTON_TYPE.SECONDARY_DETAILS}
                                    fontAwesomeIcon={'fa-trash'}
                                    title={'Remove Recommended Asset'}
                                    onClick={() => fields.remove(index)}
                                />
                            </td>

                            <td>
                                <Field name={`${collection}.name`} component={DisplayOnlyInput} />
                            </td>
                            <td>{moment(recommendedDate).format('MMM Do YYYY')}</td>
                        </tr>
                    );
                }
            });
        }

        return rows;
    };

    render() {
        const {
            recommendedCollectionOptions,
            selectedRecommendedCollection,
            selectedAssignedCollection,
            handleRecommendedCollectionChange,
            handleAddRecommendedCollection,
            fields
        } = this.props;

        const { assigned, recommended } = this._renderTableRows(fields);
        return (
            <Fragment>
                <div>
                    <label className={'form-label'}>Assign Paths</label>
                    <label className={'form-description light'}>
                        These assigned Paths are displayed to everyone in your organization in a row titled "Assigned and Recommended" on the Paths home page.
                    </label>
                    <br />

                    <div className={'row'}>
                        <div className={'col-8'}>
                            <VerbSelect
                                placeholder={'Select Assigned Path'}
                                className={'reactSelect'}
                                value={selectedAssignedCollection._id || ''}
                                labelKey={'name'}
                                valueKey={'_id'}
                                onChange={(collection) =>
                                    handleRecommendedCollectionChange(collection, 'selectedAssignedCollection')
                                }
                                options={recommendedCollectionOptions}
                            />
                        </div>
                        <div className={'col-4'}>
                            <VerbButton
                                className={'full-width'}
                                fontAwesomeIcon={'fa-plus'}
                                disabled={!selectedAssignedCollection._id}
                                onClick={() =>
                                    handleAddRecommendedCollection(fields, selectedAssignedCollection, 'ASSIGNED')
                                }
                            >
                                Assign Path
                            </VerbButton>
                        </div>
                    </div>
                    {this._renderTable(assigned)}
                </div>
                <br />
                <br />
                <label className={'form-label'}>Recommend Paths</label>
                <label className={'form-description light'}>
                    These recommended Paths are displayed to everyone in your organization in a row titled "Assigned and Recommended" on the Paths home page.
                </label>
                <br />
                <div>
                    <div className={'row'}>
                        <div className={'col-8'}>
                            <VerbSelect
                                placeholder={'Select Recommended Path'}
                                className={'reactSelect'}
                                value={selectedRecommendedCollection._id || ''}
                                labelKey={'name'}
                                valueKey={'_id'}
                                onChange={(collection) =>
                                    handleRecommendedCollectionChange(collection, 'selectedRecommendedCollection')
                                }
                                options={recommendedCollectionOptions}
                            />
                        </div>
                        <div className={'col-4'}>
                            <VerbButton
                                className={'full-width'}
                                fontAwesomeIcon={'fa-plus'}
                                disabled={!selectedRecommendedCollection._id}
                                onClick={() =>
                                    handleAddRecommendedCollection(fields, selectedRecommendedCollection, 'RECOMMENDED')
                                }
                            >
                                Recommend Path
                            </VerbButton>
                        </div>
                    </div>
                    {this._renderTable(recommended)}
                </div>
            </Fragment>
        );
    }
}
